<template>
    <div class="whole_task_div">
        <div style="font-size: 17px; font-weight: bold">
            <slot name="title"></slot>
        </div>
        <div style="font-size: 15px; margin-top: 10px">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_mini_grow_task_card"
    }
</script>

<style scoped>

    .whole_task_div{
        box-shadow: 1px 1px 5px #999999;
        padding: 20px;
    }
</style>